/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>活动详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" ref="formInline" :model="formInline" class="user-search">
      <el-form-item label="用户UID:" prop="accountId">
        <el-input maxlength="10" type="number" size="small" clearable v-model="formInline.accountId"
          placeholder="输入用户UID"></el-input>
      </el-form-item>
      <el-form-item label="活动ID:" prop="id">
        <el-input maxlength="10" type="number" size="small" clearable v-model="formInline.id"
          placeholder="输入活动ID"></el-input>
      </el-form-item>
      <el-form-item label="手机号码:" prop="phone">
        <el-input maxlength="13" type="number" size="small" clearable v-model="formInline.phone"
          placeholder="输入手机号码"></el-input>
      </el-form-item>
      <el-form-item label="昵称:" prop="nickName">
        <el-input  size="small" clearable v-model="formInline.nickName"
          placeholder="输入昵称"></el-input>
      </el-form-item>
      <el-form-item prop="platformType" label="报名平台 ">
    <el-select v-model="formInline.platformType" placeholder="不限">
        <el-option label="不限" value=""></el-option>
      <el-option label="微信小程序" value="1"></el-option>
      <el-option label="抖音小程序" value="2"></el-option>
    </el-select>
  </el-form-item>
      <el-form-item prop="isVip"  label="vip类型:">
    <el-select v-model="formInline.isVip" placeholder="不限">
      <el-option label="不限" value=""></el-option>
      <el-option label="线下超级会员" value="1"></el-option>
      <el-option label="线上VIP" value="2"></el-option>
    </el-select>
  </el-form-item>
      <el-form-item prop="sex" label="性别">
        <el-select v-model="formInline.sex" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="男" value="1"></el-option>
          <el-option label="女" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  label="年龄"   prop="beginAge"  >

      <el-input size="small" style="width: 80px;" clearable  v-model="formInline.beginAge" placeholder="不限"></el-input> -



      <el-form-item label="" prop="endAge">
        <el-input size="small" style="width: 80px;" clearable  v-model="formInline.endAge" placeholder="不限"></el-input>
      </el-form-item>

  </el-form-item>
  <el-form-item prop="maritalStatus"   label="婚姻状况">
    <el-select v-model="formInline.maritalStatus" placeholder="不限">
      <el-option label="不限" value=""></el-option>
      <el-option label="未婚" value="1"></el-option>
      <el-option label="离异" value="2"></el-option>
      <el-option label="丧偶" value="3"></el-option>
    </el-select>
  </el-form-item>

  <el-form-item prop="education" label="学历:">
    <el-select v-model="formInline.education" placeholder="请选择">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
  </el-form-item>
  <el-form-item prop="isTestAccount" label="是否测试号">
    <el-select v-model="formInline.isTestAccount" placeholder="不限">
      <el-option label="不限" value=""></el-option>
      <el-option label="是" value="1"></el-option>
      <el-option label="不是" value="0"></el-option>

    </el-select>
  </el-form-item>

  <el-form-item prop="registerType" label="注册类型">
    <el-select v-model="formInline.registerType" placeholder="不限">
      <el-option label="不限" value=""></el-option>
      <el-option v-for="item in PlatformTypeOptions" :key="item.value" :value="item.value" :label="item.label"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item prop="beginPayTime" label="报名时间">
        <el-col :span="11">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"
            v-model="formInline.beginPayTime" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
        <el-col :span="11">
          <el-form-item prop="endPayTime" label="">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" default-time="['23:59:59']"  type="datetime" placeholder="选择日期"
              v-model="formInline.endPayTime" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>

      <el-form-item prop="useStatus" label="状态">
        <el-select v-model="formInline.useStatus" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="未签到" value="1"></el-option>
          <el-option label="已签到" value="2"></el-option>
          <el-option label="已退款" value="3"></el-option>
          <el-option label="已过期" value="4"></el-option>
          <el-option label="已失效" value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="payType" label="支付类型">
        <el-select v-model="formInline.payType" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="微信支付" value="1"></el-option>
          <el-option label="在线支付" value="2"></el-option>

        </el-select>
      </el-form-item>
      <el-form-item prop="joinType" label="会员类型">
        <el-select v-model="formInline.joinType" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="活动付费会员" value="1"></el-option>
          <el-option label="活动免费会员" value="2"></el-option>
          <el-option label="活动赠送会员" value="3"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button @click="resetForm('formInline')">重置</el-button>
      </el-form-item>
      <el-form-item>
      </el-form-item>
      <!-- <div style=" float: right; margin-right: 50px; margin-bottom: 0px; ">
        <el-button size="small" type="info" icon="el-icon-top" @click="addCogilg">返回上一页</el-button>
      </div> -->
    </el-form>

    <!--列表-->
    <el-table id="educe-table" size="small" ref="multipleTable" stripe :data="listData" highlight-current-row
      v-loading="loading" @select-all="selectall" @select="select" border element-loading-text="拼命加载中"
      style="width: 100%; font-size: 18px;">

      <el-table-column align="center" prop="id" label="活动ID" width="100">
        <template slot-scope="scope">

          <span style="font-size: 29px; font-weight: 600; color: #885DDF;">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="标题" width="200">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.cost == 0" type="primary" disable-transitions>免费活动</el-tag>
          <el-tag v-if="scope.row.cost > 0" type="success" disable-transitions>精选活动</el-tag><br>
          <span>{{ scope.row.title }}</span>
        </template>

      </el-table-column>
      <el-table-column style="font-size: 30px;" align="center" prop="accountId" label="用户UID" width="150">


        <template slot-scope="scope">
          <img style="width:60%;" v-if="scope.row.isVip==1" src="https://test-cos.ynhlminiapp.com/ae6990bf-1687-4fee-b1c4-f579d5caf927.png" alt=""><br>
          <span style="font-size: 29px; font-weight: 600; color: #9A75E4;">{{scope.row.accountId}}</span><br>
          <img v-if="scope.row.isJoinVipClub==1" style="width: 90px; height: 30px; margin-top: 10px;" src="https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/a3c71c1d-165d-4688-9db4-0f63541cab90.png" alt="">
          <br><span v-if="scope.row.isMember==1" style="width: 90px; height: 30px; margin-top: 10px; color: red; font-size: 12px" >线上VIP</span>
        </template>



      </el-table-column>
      <el-table-column prop="headIcon"  align="center" label="头像" width="180">
        <template slot-scope="scope">
          <el-image style="width: 150px; height: 150px;" :src="scope.row.headIcon" :preview-src-list="[scope.row.headIcon]" />
          <span v-if="scope.row.headIconStatus==1" style="color: #3399FF;">待审核</span>
          <span v-if="scope.row.headIconStatus==2" style="color: #34D0B4;" >{{scope.row.appearanceScore}}</span>
          <span v-if="scope.row.headIconStatus==3" style="color: #CF1F1F;">审核未通过</span>
        </template>
      </el-table-column>
      <el-table-column  align="center"  prop="status" label="账号状态" width="150">
        <template slot-scope="scope">
          <span style="color: #3399FF;" v-if="scope.row.accountStatus==1" >正常</span>
          <span style="color: darkgoldenrod;" v-if="scope.row.accountStatus==2">注销中</span>
          <span  style="color: red;"  v-if="scope.row.accountStatus==3||scope.row.accountStatus==null">已注销</span>
        </template>
      </el-table-column>

      <el-table-column prop="closeTime" label="基本信息" width="200">
        <template slot-scope="scope">
         <div :style=" scope.row.sex==1? 'color: rgb(52, 208, 180);':'color: #FF1D87;'  ">昵称:{{ scope.row.nickName}}/{{ scope.row.age }}岁/{{ scope.row.sex==1?'男':"女"  }}</div>
         <div>学历:{{scope.row.educationDesc  }}</div>
         <div>身高:{{scope.row.height}}{{scope.row.height?'cm':""}}</div>
         <div>月收入:{{scope.row.monthlyIncomeDesc  }}</div>
         <div>婚姻状况:{{scope.row.maritalStatusDesc  }}</div>
        </template>
      </el-table-column>


      <el-table-column prop="phone" label="手机" width="140">
        <template slot-scope="scope">
          <div>{{scope.row.phone,userifom|mobileStr}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="payTimeMills" label="报名时间" width="120">
        <template slot-scope="scope">
          <div >{{ scope.row.payTimeMills | timestampToTime }}</div>

        </template>

      </el-table-column>
      <el-table-column  align="center"  prop="amount" label="报名费" width="100">
        <template slot-scope="scope">
          <div >¥{{ scope.row.amount }}</div>

        </template>

      </el-table-column>
      <el-table-column  align="center"  prop="payType" label="支付类型" width="140">
        <template slot-scope="scope">
          <div >{{ scope.row.payType==1?"微信支付":"在线支付" }}</div>
        </template>
      </el-table-column>
      <el-table-column  prop="platformType"  align="center" label="报名平台" width="150">
        <template slot-scope="scope">
        <div  style="color: #F9AD00;" >{{ scope.row.platformType==1?'微信小程序':"抖音小程序" }} </div>
      </template>
    </el-table-column>
      <el-table-column  align="center"  prop="amount" label="会员类型" width="140">
        <template slot-scope="scope">
            <!-- joinType -->
          <div v-if="scope.row.joinType==1">付费会员</div>
          <div v-if="scope.row.joinType==2">免费会员</div>
          <div v-if="scope.row.joinType==3">赠送会员</div>
        </template>
      </el-table-column>
      <el-table-column  align="center"  prop="useStatus" label="签到状态" >
        <template slot-scope="scope">
            <!-- joinType -->
          <div v-if="scope.row.useStatus==1">未签到</div>
          <div v-if="scope.row.useStatus==2">已签到</div>
          <div v-if="scope.row.useStatus==3">已退款</div>
          <div style="color: #CF1F1F;" v-if="scope.row.useStatus==4">已过期</div>
          <div style="color: #CF1F1F;" v-if="scope.row.useStatus==5">已失效</div>
        </template>
      </el-table-column>
      <el-table-column  fixed="right" align="center" label="操作" width="130">
        <template slot-scope="scope">
            <el-dropdown trigger="click" @click="handleClickDropDown('design', scope.row.id)" split-button @command="adddadad" type="primary">
  管理
  <el-dropdown-menu slot="dropdown" >
    <el-dropdown-item   :command="beforeHandleCommand('a', scope.row.accountId)">基本信息</el-dropdown-item>
    <el-dropdown-item :command="beforeHandleCommand('b', scope.row.id)">发送短信</el-dropdown-item>
    <el-dropdown-item :command="beforeHandleCommand('c', scope.row)">发送系统通知</el-dropdown-item>

  </el-dropdown-menu>
</el-dropdown>
          <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">基本信息</el-button>
          <el-button size="mini" type="success" @click="deleteUser(scope.$index, scope.row)">发送短信</el-button>
          <el-button size="mini" type="warning"
            @click="recommend(scope.$index, scope.row)">发送系统通知</el-button> -->

        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"
      @size-change="handleSizeChange" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <!-- <div style="margin-top: 20px;">
      <el-button @click="selectalls(listData)" type="primary">全选</el-button>
      <el-button @click="imporList" type="success">导出数据</el-button>

    </div> -->
    <el-dialog title="温馨提示" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">

        <span style="margin-left: 52px;">确定要将该活动推荐吗？</span><br>

        <el-form-item label="推荐排序" prop="deptName">
          <el-input style="width: 200px;" size="small" type="number" v-model="recommendform.index" auto-complete="off"
            placeholder="请输入排序"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title"
          @click="submitForm('editForm')">确定推荐</el-button>
      </div>
    </el-dialog>

    <!-- 系统通知 -->
    <el-dialog
  title="发送系统通知"
  :visible.sync="centerDialogVisible"
  width="30%"
  center>
  <span>接收用户UID:{{  userList.accountId}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  <span>用户昵称:{{  userList.nickName}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  <span>手机号码:{{  userList.phone}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br>

  <el-form :model="userList"  :rules="rules" ref="userList" style="margin-top: 30px;">
    <el-form-item style="margin-left: -30px;" prop="content" label="通知内容" :label-width="formLabelWidth">
      <el-input

  type="textarea"
  placeholder="请输入内容"
  v-model="userList.content"
  maxlength="500"
  show-word-limit
>
</el-input>
    </el-form-item>

  </el-form>



  <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary"   @click="submitFormTs('userList')">确定发送</el-button>
  </span>
</el-dialog>

  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import {mobileStr}from "../../utils/util"
import Axios from 'axios'
import { login } from "../../api"
import { homeData } from '../../request/home'
import Vue from 'vue'
import Pagination from '../../components/Pagination'
import {PlatformTypeOptions} from "../../enums/userEnum";
export default {
  computed: {
    PlatformTypeOptions() {
      return PlatformTypeOptions
    }
  },
  data() {
    return {
      form:'',
      ssoServer:"",
      userList:{
        content:"",
        accountId:"",
      },
      userifom:"",
      dialogVisible: false,
      value: "",
      options123: [],
      centerDialogVisible:false,
      options1234123: [],
      loadings:false,
      aData: new Date(),
      formLabelWidth:'100px',

      adder: "",
      recommendform: {
        index: "",
        id: ""
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList: [],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',

      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },
      options: [{
          value: 1,
          label: '中专以下'
        }, {
          value: 2,
          label: '中专'
        }, {
          value: 3,
          label: '大专'
        }, {
          value: 4,
          label: '本科'
        }, {
          value: 5,
          label: '硕士'
        },{
          value: 6,
          label: '博士'
        },{
          value: 7,
          label: '博士后'
        }],






      // rules表单验证
      rules: {
        index: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '通知内容不能为空', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        registerType:"",
        isVip:"",
        platformType:"",
        id:"",//活动id
        accountId:"",//用户id
        // beginAge:"",//开始年龄
        // endAge:"",//结束年龄
        phone:"",//手机号
        nickName:"",//用户昵称
        sex:"",//性别
        beginAge:"",//开始年龄
        endAge:"",//结束年龄
        maritalStatus:"",//婚姻状况
        education:"",//学历
        isTestAccount:"",//是否是测试号
        beginPayTime:"",//报名开始时间
        endPayTime:"",//报名结束时间
        useStatus:"",//状态
        payType:"",//支付类型
        joinType:"",//会员类型
        current: 1,
        size: 20,
        // token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      }
    }
  },

  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */

  created() {
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
   this.formInline.id=this.$route.query.id

    this.value=(new Date()).getTime();

// console.log(times);
    // console.log(this.aData.gettime);

    // this.value =
    //   this.aData.getFullYear() + "-" + (this.aData.getMonth() + 1) + "-" + this.aData.getDate();
    // console.log(this.value) //2019-8-20




    let tokenId = localStorage.getItem('tokenId');
    this.adder = tokenId



    // this.getdata(this.formInline)
  },
  mounted() {
    this.userifom= localStorage.getItem('userifom');
    this.formLIst()
    this.getAddress()
    // this.getAddresss()


  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    submitFormTs(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {


            const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();



          Axios({
        method: 'post',
        url: this.ssoServer+'//api/activity/sendCustomSysNoticeById',
        headers: {
          tokenId: this.adder
        },
        data:this.userList
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }else if(res.data.code==0){
          this.centerDialogVisible=false,
          this.$message({
              type: 'success',
              message: '发送成功'
            })

        }else{
          this.$message({
              type: 'success',
              message: res.data.message
            })
        }
        // console.log("getAddressList", res.data.data);
        // this.options123 = res.data.data

      })





        }, 500);










            // alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },





beforeHandleCommand(flag, command) { // flag为传递的参数
  return {
     'flag': flag,
     'command': command
  }
},

handleClickDropDown(type, formItem) {
  console.log(type, formItem);
},

    adddadad(command){
        if(command.flag=='a'){
          this.$router.push({
    path:"/goods/userGoods",
    query:{ //query是个配置项
        id:command.command,
        index:this.$route.query.id
    }
})

        }else if(command.flag=='c'){
          this.userList.accountId =command.command.accountId
          this.userList=command.command
          // console.log(command.);

          this.centerDialogVisible=true


          // console.log('11111');
        }

    },
    // 推荐
    // getCurrentTime() {
    //     //获取当前时间并打印
    //     var _this = this;
    // let yy = new Date().getFullYear();
    // let mm = new Date().getMonth()+1;
    // let dd = new Date().getDate();
    // let hh = new Date().getHours();
    // let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
    // let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
    // _this.gettime = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss;
    // console.log(_this.gettime)
    // },
    recommend(i, f) {

      if (i == 3) {
        this.recommendform.id = f.id
        this.recommendform.index = 0

        this.$confirm('确定要将该活动推荐取消吗?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {


          Axios({
            method: 'post',
            url: this.ssoServer+'/api/activity/updateIndex',

            headers: {
              tokenId: this.adder
            },
            data: this.recommendform
          }).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '取消成功'
              })
              this.formLIst()
            }
          })

        }).catch(() => {

        });
        return

      }
      this.recommendform.id = f.id

      this.editFormVisible = true
      this.recommendform.index = ''

    },




    addCogilg() {
      this.$router.push({
        path: "/Eventmanagement/activities",

      })

    },
    selectall(val) {
      // console.log(val);

      let data = []
      // this.importList=''
      val.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // this.importList
      // console.log(val);
    },


    getAddress() {

      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',

        headers: {
          tokenId: this.adder
        }
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        // console.log("getAddressList", res.data.data);
        this.options123 = res.data.data

      })
    },


    change1(e) {
      console.log("change1", e);
      if (e.length === 1) {
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if (e.length === 2) {
        this.formInline.registerAddress = e[1];
      }
    },

    selectalls(rows) {

      if (rows) {
        let data = []
        rows.forEach((item) => {
          data.push(item.id)
          this.importList = data
          console.log(this.importList);

        })
        rows.forEach(row => {

          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        console.log('1212112');
        this.importList = []

        this.$refs.multipleTable.clearSelection();//清除全选
      }


    },

    onChange(e) {

      this.formInline.activityAddressCode = e[1]
      // console.log( this.formInline.registerAddress);


    },
    selectall(val) {

      let data = []
      val.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // this.importList
      console.log(val);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出数据
    imporList() {
      if (this.importList.length == 0) {

        this.$message({
          type: 'warning',
          message: '请选择要导出的数据'
        })
        return

      } else {
        Axios({
          method: 'post',

          url: this.ssoServer+'/api/platform-account/exportExcel',
          headers: {
            tokenId: this.adder
          },
          data: {
            accountIds: this.importList,
            searchType: 1
          },
          responseType: 'blob'
        }).then(res => {
          const link = document.createElement('a') // 创建a标签
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
          link.href = window.URL.createObjectURL(blob)
          const filename = res.headers['content-disposition'].split('filename=')[1]
          link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
          link.click()
          window.URL.revokeObjectURL(link.href)
        })


      }




    },
    select(selection, row) {

      let data = []
      // this.importList=''
      selection.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // console.log(this.importList);
      // console.log(selection);
    },
    resetForm(formInline) {
      //  this.formInline =''
      this.$refs[formInline].resetFields();
    },


    formLIst() {

      // let accountListReqVO= this.formInline
      Axios({
        method: 'get',

        url: this.ssoServer+'/api/activity/getJoinAccountList',
        headers: {
          tokenId: this.adder
        },
        params: this.formInline


      }).then(res => {
        console.log(res);
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        this.listData = res.data.data.list

        this.pageparm.currentPage = this.formInline.current
        this.pageparm.pageSize = this.formInline.size
        this.pageparm.total = res.data.data.total
        // console.log(res);
      })

    },
    formatData(row, column, cellValue, index) {

      //把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
      //最终返回 s 就可以了
      var s = new Date(cellValue).toLocaleString();
      return s;
    },
    handleSizeChange(e) {
      // reru console.log(e.pageSize);
      this.formInline.size = e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
      // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
      this.formInline.current = 1
    // console.log(this.formInline);
      this.formLIst()
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.deptId = row.deptId
        this.editForm.deptName = row.deptName
        this.editForm.deptNo = row.deptNo
      } else {
        this.title = '添加'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          Axios({
            method: 'post',
            url: this.ssoServer+'/api/activity/updateIndex',

            headers: {
              tokenId: this.adder
            },
            data: this.recommendform
          }).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '推荐成功'
              })
              this.editFormVisible = false
              this.formLIst()

            }else{
              this.$message({
                type: 'warning',
                message: res.data.message
              })
              return

            }


          })
        }
      })
    },
    // async logins() {
    //     // 网络请求
    //     let data = await login('1111111');
    //     // let token = data.token;
    //     // 本地  vuex
    //     // this.$store.commit('LOGIN_IN',token);
    //     this.$router.replace("/")
    // },

    // 删除公司

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/Eventmanagement/activeUsers.vue